export default "__VITE_ASSET__CFcJsbmy__"